// extracted by mini-css-extract-plugin
module.exports = {"icon-addon":"_1SWcGjJsjLqTLkYGUmiYvn","icon-pos":"_2fyn7hIpAMlEIfgBO6a2W1"};